export default __webpack_public_path__ + "static/media/cickstay.a2d000c0.png";